// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import Credentials from "../Common/Credentials.js";
// import mastersIcom from "../images/Icons/generic.png"
// import dashboardIcon from "../images/Icons/dashboard.png"
// import "../NewUI/NewMenu.css"; // Import the shared CSS file
// import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";

// const MastersMenu = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Masters")
//   }, [])

//   return (
//     <div>
//       <Header />
//       <Menu />

//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <Breadcrumb breadcrumbs={[{name:"Home",path:"/dashboard"},{name:"Masters",path:null}]}/>
//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>

//                 <div className="menu-sections-container">
//                   {screens.includes("Admin Masters") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-masters" src={mastersIcom} />
//                         <span className="menu-section-title-text">Admin Masters</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/users" }}
//                             state={{ message: "" }}
//                           >
//                             Users
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/roles" }}
//                             state={{ message: "" }}
//                           >
//                             Roles
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/usercustomers" }}
//                             state={{ message: "" }}
//                           >
//                             User-Customers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salescaltable" }}
//                             state={{ message: "" }}
//                           >
//                             Sales Calculation
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/customerterms" }}
//                             state={{ message: "" }}
//                           >
//                             Customer Terms
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/bank" }}
//                             state={{ message: "" }}
//                           >
//                             Banks
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}

//                   {screens.includes("General Masters") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-masters" src={mastersIcom} />
//                         <span className="menu-section-title-text">General Masters</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/employees" }}
//                             state={{ message: "", employeetype: 0 }}
//                           >
//                             Employees
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/customers" }}
//                             state={{ message: "" }}
//                           >
//                             Customers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/suppliers" }}
//                             state={{ message: "" }}
//                           >
//                             Suppliers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/agents" }}
//                             state={{ message: "" }}
//                           >
//                             Agents
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/assigntype" }}
//                             state={{ message: "" }}
//                           >
//                             Assign Type
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/warehouse" }}
//                             state={{ message: "" }}
//                           >
//                             Org Unit
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/department" }}
//                             state={{ message: "" }}
//                           >
//                             Department
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/workcenter" }}
//                             state={{ message: "" }}
//                           >
//                             Workcenter/Production Unit
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/transporter" }}
//                             state={{ message: "" }}
//                           >
//                             Transporter
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(MastersMenu);







import React from 'react';
import {
  FolderLock,
  ArrowRightLeft,
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser,
  CalculatorIcon
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const MastersMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
    {
      title: 'Admin Masters',
      subtitle: 'Clearance & credentials',
      icon: ShieldUser,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'users', label: 'Users', desc: 'Login login credentials and statuses', icon: Users, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 hover:bg-indigo-200 text-indigo-700', path: '/users', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
        { id: 'roles', label: 'Roles', desc: 'Cleared staff security permissions', icon: FolderLock, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:bg-purple-100 text-purple-707', path: '/roles', brandColor: theme === "classic" ? '#4d4d4d' : '#7C3AED' },
        { id: 'usr_cust', label: 'User-Customers', desc: 'Client portal linkages', icon: Users, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:bg-teal-100 text-teal-700', path: '/usercustomers', brandColor: theme === "classic" ? '#4d4d4d' : '#14B8A6' },
        { id: 'sales_calc', label: 'Sales Calculation', desc: 'Tax calculation formulas config', icon: Calculator, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:bg-amber-100 text-amber-700', path: '/salescaltable', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'cust_terms', label: 'Customer Terms', desc: 'Rebate agreements outlines', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-pink-50 hover:bg-pink-100 text-pink-700', path: '/customerterms', brandColor: theme === "classic" ? '#4d4d4d' : '#EC4899' },
        { id: 'banks', label: 'Banks', desc: 'Corporate clearing house codes', icon: Building2, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-sky-50 hover:bg-sky-100 text-sky-700', path: '/bank', brandColor: theme === "classic" ? '#4d4d4d' : '#0EA5E9' },
        { id: 'tax', label: 'Tax', desc: 'Tax rates', icon: CalculatorIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-yellow-50 hover:bg-yellow-100 text-yellow-700', path: '/taxes', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },

      ]
    },
    {
      title: 'General Masters',
      subtitle: 'Physical organizational elements',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'employees', label: 'Employees', desc: 'Primary employee information', icon: Users, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-pink-50 hover:bg-pink-100 text-pink-700', path: '/employees', brandColor: theme === "classic" ? '#4d4d4d' : '#EC4899' },
        { id: 'customers', label: 'Customers', desc: 'Approved customer accounts directory', icon: Users, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:bg-emerald-100 text-emerald-700', path: '/customers', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'suppliers', label: 'Suppliers', desc: 'B2B vendors parameters', icon: Handshake, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:bg-indigo-100 text-indigo-700', path: '/suppliers', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
        { id: 'agents', label: 'Agents', desc: 'Revolving broker agents', icon: Users, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:bg-rose-100 text-rose-700', path: '/agents', brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E' },
        { id: 'org_unit', label: 'Organization Unit', desc: 'Legal business subsidiary logs', icon: Building2, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:bg-blue-100 text-blue-700', path: '/warehouse', brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6' },
        { id: 'dept', label: 'Department', desc: 'System structural divisions', icon: Grid, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-violet-50 hover:bg-violet-100 text-violet-700', path: '/department', brandColor: theme === "classic" ? '#4d4d4d' : '#8B5CF6' },
        { id: 'transp', label: 'Transporter', desc: 'Freight and cargo carriers', icon: Truck, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:bg-purple-105 text-purple-700', path: '/transporter', brandColor: theme === "classic" ? '#4d4d4d' : '#7C3AED' }
      ]
    }
  ]


  const onSelectItem = (path) => {
    navigate(path);
  }

  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>

      {/* <Header />
      <Menu />

         <section className="content-wrapper"> */}
      <Layout menu="masters">
        <div className="menu-container tw-ml-4 tw-mr-2">
          <div
            id="dashboard-content-area"
            className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
          >
            {/* Upper Hero Grid */}
            <div
              id="hero-welcome-banner"
              className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
            >
              {/* Background Blur Shapes */}
              <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

              {/* Left Content */}
              <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Masters", path: null }]} />
                <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
                  Masters Management
                </h1>

                <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
                  Manage your firm&apos;s legal structural units, employee profiles, access credentials, and wholesale customer catalogs.
                </p>
              </div>

              {/* 3D SVG Security Badging Illustration */}
              <div className="tw-flex tw-justify-center md:tw-justify-end mt-0 tw-relative tw-group">
                {/* <div className="tw-w-40 tw-h-40 tw-relative tw-flex tw-items-center tw-justify-center tw-animate-bounce tw-duration-1000 tw-ease-in-out" style={{ animationDuration: '4.5s' }}> */}
                <div className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center">

                  <div className="tw-absolute tw-bottom-4 tw-w-28 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>

                  <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl">
                    <defs>
                      <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#818CF8" />
                        <stop offset="100%" stopColor="#4F46E5" />
                      </linearGradient>
                      <linearGradient id="keyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#FBBF24" />
                        <stop offset="100%" stopColor="#D97706" />
                      </linearGradient>
                    </defs>
                    <path d="M100 20 L160 50 L160 110 C160 160 100 185 100 185 C100 185 40 160 40 110 L40 50 Z" fill="url(#shieldGrad)" />
                    <path d="M100 28 L152 54 L152 106 C152 148 100 171 100 171 C100 171 48 148 48 106 L48 54 Z" fill="#312E81" opacity="0.4" />
                    {/* Inner Key Icon representation */}
                    <circle cx="100" cy="85" r="20" fill="url(#keyGrad)" />
                    <rect x="94" y="100" width="12" height="40" rx="3" fill="url(#keyGrad)" />
                    <rect x="94" y="115" width="22" height="8" rx="2" fill="url(#keyGrad)" />
                    <rect x="94" y="130" width="18" height="8" rx="2" fill="url(#keyGrad)" />
                    <circle cx="100" cy="85" r="8" fill="#4F46E5" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Main Grid */}
            <div
              id="erp-columns-grid"
              className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
            >


              {/* Menus */}
              {newsections.map((section) => {
                // const Icon = section.icon;
                return (
                  <div
                    key={section.title}
                    id="section-col-masters"
                    className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
                  >
                    <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
                      <div
                        className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
                      >
                        <FolderLock size={22} />
                        {/* <Icon size={22} color={section.iconColor} /> */}
                      </div>

                      <div>
                        <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
                          {section.title}
                        </h2>

                        <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
                          {section.subtitle}
                        </p>
                      </div>
                    </div>

                    <div className="tw-space-y-3 tw-flex-1">
                      {section.items.map((item) => {
                        const Icon = item.icon;

                        return (
                          <button
                            id={`subsection-btn-${item.id}`}
                            key={item.id}
                            onClick={() => onSelectItem(item.path)}
                            className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
                          >
                            <div className="tw-flex tw-items-center tw-gap-3.5">
                              <div
                                className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                              >
                                <Icon size={16} color={item.brandColor} />
                              </div>

                              <div>
                                <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                                  {item.label}
                                </h4>

                                {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                              </div>
                            </div>

                            <ChevronRight
                              size={16}
                              className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
                            />
                          </button>
                        );
                      })}
                    </div>
                  </div>)
              }
              )}
            </div>

          </div>
        </div>
      </Layout>
      {/* </section>
      <Footer /> */}
    </div>
  );
}
export default withRouter(MastersMenu);